<rt-collapsible-card
  [uniqKey]="'candidate-offer-evaluation-form-' + formName()"
  [collapseDisabled]="!hasAnswers()"
  [forceCollapsed]="!hasAnswers()"
  hasLeftSlotDesc
>
  <div leftSlot layout layout-align-items-center>
    @if (form().hasHiddenEvaluations) {
      <rt-icon
        name="visibility-off"
        size="medium"
        colorToken="colorIconLowDisabled"
        margin-right-small-x
      />
    }
    <rt-heading variant="heading large">
      {{ 'app.evaluation_tab.form_details.results_from' | translate: { formName: formName() } }}
    </rt-heading>
    @if (form().reviewersCount) {
      <rt-badge
        color="draft"
        iconName="account-group"
        [text]="form().reviewersCount"
        margin-left-small-x
      />
    }
  </div>

  @if (hasAnswers()) {
    <div rightSlot (click)="$event.stopPropagation()">
      <rt-segmented-control
        type="view-switcher"
        [segmentedButtons]="groupByButtons()"
        (segmentedButtonClicked)="onGroupByClicked($event)"
      />
    </div>
  }

  <ng-container bellowLeftSlot>
    @if (form().hasHiddenEvaluations) {
      <span class="description description--hidden">
        {{ 'app.evaluation_tab.form_details.hidden_evaluation_description' | translate }}
      </span>
    } @else {
      <span class="description">{{ form().description }}</span>
    }
  </ng-container>

  <div collapsible class="questions" padding-lr padding-bottom>
    @for (question of questions(); track question.questionHash) {
      <rt-candidate-offer-evaluation-question
        [question]="question"
        [theme]="theme()"
        [useProsemirror]="useProsemirror()"
        [showPositionButton]="showPositionButton()"
        (viewPosition)="viewPosition.emit()"
      />
    }
    @for (stage of stages(); track stage.stage?.id ?? $index) {
      <rt-candidate-offer-evaluation-stage
        [stage]="stage"
        [theme]="theme()"
        [useProsemirror]="useProsemirror()"
        (edit)="edit.emit($event)"
        (delete)="delete.emit($event)"
      />
    }
  </div>
</rt-collapsible-card>
